<template>
  <div class="row">
    <router-link to="/portal/residential/overview" class="btn btn-sm">
      <button class="btn btn-warning">Overview</button>
    </router-link>
    <router-link to="/portal/residential/callhistory" class="btn btn-sm">
      <button class="btn btn-warning">Call History</button>
    </router-link>
    <router-link to="/portal/residential/topup" class="btn btn-sm">
      <button class="btn btn-warning">Topup</button>
    </router-link>
    <router-link to="/portal/residential/notification" class="btn btn-sm">
      <button class="btn btn-warning">Notification</button>
    </router-link>
    <router-link to="/portal/residential/term_and_condition" class="btn btn-sm">
      <button class="btn btn-warning">Term and Condition</button>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "residential-menu",
  mouted() {
    console.log("User Menu");
    console.log(route.meta);
  },
  methods: {
    getBreadName(route) {
      return route.name;
    },
  },
};
</script>

<style scoped></style>
